import { render, staticRenderFns } from "./DiagnosticTextPanel.vue?vue&type=template&id=66a78870&scoped=true&"
import script from "./DiagnosticTextPanel.vue?vue&type=script&lang=js&"
export * from "./DiagnosticTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticTextPanel.vue?vue&type=style&index=0&id=66a78870&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a78870",
  null
  
)

export default component.exports